
import { Base } from '../base-component';
import * as Swiper from 'swiper/dist/js/swiper.js';

import '../../interfaces/slider.interface';
import './slider.component.scss';

export default class Slider {

	constructor() {}

	static init(container, config: SwiperOptions) {

		// tslint:disable-next-line:no-unused-expression
		new Swiper(container, config);

	}

}




// WEBPACK FOOTER //
// ./components/slider/slider.component.ts